import {PhoneHQSpinner} from 'ch3-ui-lib';

const FilePreview: React.FC<{
    file: File;
    preview?: string;
    index: number;
    onRemove: (index: number) => void;
    isSending: boolean;
}> = ({file, preview, index, onRemove, isSending}) => {
    const isImage = file.type.startsWith('image/');
    const formatFileSize = (bytes: number) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getFileIcon = (fileType: string) => {
        if (fileType.startsWith('image/')) return '🖼️';
        if (fileType.startsWith('video/')) return '🎥';
        if (fileType.startsWith('audio/')) return '🎵';
        if (fileType.includes('pdf')) return '📄';
        if (fileType.includes('word') || fileType.includes('document')) return '📝';
        if (fileType.includes('excel') || fileType.includes('spreadsheet')) return '📊';
        if (fileType.includes('powerpoint') || fileType.includes('presentation')) return '📈';
        if (fileType.includes('zip') || fileType.includes('rar') || fileType.includes('7z')) return '🗜️';
        return '📎';
    };

    return (
        <div className="relative inline-block m-1 border border-fill-subtle rounded-lg bg-surface">
            {isImage && preview ? (
                <img
                    src={preview}
                    alt={`Preview ${index + 1}`}
                    className="w-16 h-16 object-cover rounded-lg"
                />
            ) : (
                <div className="w-16 h-16 flex flex-col items-center justify-center p-1 rounded-lg">
                    <div className="text-lg">{getFileIcon(file.type)}</div>
                    <div className="text-xs text-ink-muted-strong truncate w-full text-center">
                        {file.name.substring(0, 8)}...
                    </div>
                </div>
            )}

            {/* File info overlay */}
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-white text-xs p-1 rounded-b-lg">
                <div className="truncate">{file.name}</div>
                <div>{formatFileSize(file.size)}</div>
            </div>

            {!isSending && (
                <button
                    onClick={() => onRemove(index)}
                    className="absolute -top-2 -right-2 w-5 h-5 bg-slate-700/90 text-white rounded-full flex items-center justify-center text-xs border-white border-2 border-solid"
                    data-tooltip="Remove file"
                >
                    ×
                </button>
            )}
            {isSending && (
                <div className={'bg-surface rounded-full p-1 border-line border absolute -top-2 -right-2'}>
                    <PhoneHQSpinner className="m-auto w-4-h-4"/>
                </div>
            )}
        </div>
    );
};
export default FilePreview;